import React, { useEffect, useState } from "react";
import { Mail, Info } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { PageHeader, Loading, EmptyState } from "@/components/common";
import { DataTable } from "@/components/DataTable";

const DELIVERY = {
  "Sent": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Logged (mock)": "bg-slate-100 text-slate-600 border-slate-200",
  "Failed": "bg-red-50 text-red-700 border-red-200",
  "No recipient": "bg-amber-50 text-amber-700 border-amber-200",
};

export default function Communications() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/communications").then((r) => setRows(r.data)).finally(() => setLoading(false)); }, []);

  const columns = [
    { key: "date_sent", label: "Date", render: (r) => fmtDateTime(r.date_sent) },
    { key: "message_type", label: "Type", className: "font-medium text-slate-700" },
    { key: "channel", label: "Channel" },
    { key: "recipient", label: "Recipient" },
    { key: "related_client_name", label: "Client", render: (r) => r.related_client_name || "—" },
    { key: "subject", label: "Subject", render: (r) => <span className="text-xs text-slate-500">{r.subject}</span> },
    { key: "delivery_status", label: "Delivery", render: (r) => <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-semibold border ${DELIVERY[r.delivery_status] || DELIVERY["Logged (mock)"]}`}>{r.delivery_status}</span> },
  ];

  return (
    <div>
      <PageHeader title="Communications" subtitle="Client email & SMS log — confirmations, reminders and reports" icon={Mail} />
      <div className="mb-4 rounded-xl border border-sky-200 bg-sky-50 p-3 flex items-start gap-2 text-sm text-sky-700">
        <Info size={16} className="mt-0.5 shrink-0" />
        <span>Email is <b>logged (mock)</b> until a provider key is configured. Add <code className="bg-white/60 px-1 rounded">RESEND_API_KEY</code> to the backend to send real emails — no code changes needed.</span>
      </div>
      <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">
        {loading ? <Loading /> : <DataTable columns={columns} rows={rows} empty={<EmptyState icon={Mail} title="No communications yet" hint="Publishing a schedule or sending a confirmation records here." />} />}
      </div>
    </div>
  );
}
